import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Breadcrumbs,
  Link,
  Typography,
  Rating,
} from "@mui/material";
import { getProductById } from "../service/productService";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DetailPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const loadingLabel = t("loading");
  const initialState = {
    name: loadingLabel,
    author: loadingLabel,
    category: loadingLabel,
    score: 0,
  };
  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const product = await getProductById(id);
      if ("error" in product) {
        setError(true);
      } else {
        setState(product);
        setLoading(false);
      }
    };

    if (id) fetchData();
  }, []);

  if (error) {
    return <>{"Error"}</>;
  }

  if (loading) {
    return <>{loadingLabel}</>;
  }

  return (
    <Container>
      <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          {t("detail-bread-summary")}
        </Link>
        <Link underline="hover" color="inherit" href="/">
          {state.category}
        </Link>
        <Typography color="text.primary">{state.name}</Typography>
      </Breadcrumbs>
      <Box m={2}>
        <Typography variant="h2" gutterBottom>
          [{state.author}] {state.name}
        </Typography>

        {state.incomplete && (
          <Typography variant="h5" display="block" gutterBottom>
            {t("incomplete")}
          </Typography>
        )}
        <Typography variant="h6" gutterBottom>
          {state.CP}
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          {t("detail-bread-basic-info")}
        </Typography>
        <Rating value={state.score} precision={0.5} readOnly />
        <Typography variant="body1" gutterBottom>
          {t("word-count")}：{state.wordCount}
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          {t("intro")}
        </Typography>
        <Typography variant="body1" gutterBottom paragraph>
          {state.content}
        </Typography>

        <Typography variant="overline" display="block" gutterBottom>
          {state.tags}
        </Typography>
      </Box>
    </Container>
  );
};

export default DetailPage;
